var App = App || {};

App.SolutionsFinder = (function ($) {
    "use strict";

    function init() {
        var $lifeEvents = $("#life-events"),
            $lifeEventsTab = $lifeEvents.find("a.nav-link");

        $lifeEventsTab.on("click", function (e) {
            var $this = $(this);

            $lifeEventsTab.attr("aria-expanded", false);

            if ($this.hasClass("active")) {
                e.preventDefault();
                e.stopPropagation();

                var $tabContent = $this.attr("aria-controls");

                $this
                    .attr("aria-expanded", false)
                    .removeClass("active");

                $("#" + $tabContent).removeClass("active show");
            } else {
                $this.attr("aria-expanded", true);
            }
        });

        $lifeEventsTab.on("mouseover", function () {
            var $this = $(this),
                $icon = $this.find(".icon");

            $icon.addClass("animate__animated animate__faster animate__pulse");
        });

        $lifeEventsTab.on("mouseout", function () {
            var $this = $(this),
                $icon = $this.find(".icon");

            $icon.removeClass("animate__animated animate__faster animate__pulse");
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.SolutionsFinder.init();
});